import React, { useEffect, useState } from "react";
import CountCard from "../UI/Dashboard/CountCard";
import Panels from "../UI/Dashboard/panels";
import Employees from "../UI/Dashboard/employees";
import { FaSolarPanel, FaUsers } from "react-icons/fa";
import { api_Routes } from "../tools/api_Routes";
import { Helper } from "../tools/Helper";
import { Box, CircularProgress } from "@mui/material";
import { MdMiscellaneousServices } from "react-icons/md";
import Roles from "../UI/Dashboard/roles";
import styled from "styled-components";
import PaymentMethods from "../UI/Dashboard/payment-methods";
import PaymentStatus from "../UI/Dashboard/payment-status";
import Status from "../UI/Dashboard/status";

const Styles = styled.div`
  padding-bottom: 80px;
  .contain {
    @media (max-width: 1260px) {
      flex-direction: column;
      align-items: center;
      gap: 50px;
    }
  }
`;

const Dashboard = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const getData = async () => {
    setIsLoading(true);
    const { response, message } = await Helper.Get({
      url: `${api_Routes.dashboard.getStatistics}`,
      hasToken: true,
    });
    if (response) {
      setData(response?.data);
    } else {
      setData([]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return isLoading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100dvh - 290px)",
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <Styles>
      <div className="flex justify-around items-start gap-4 flex-wrap contain">
        <div>
          <CountCard
            title={"Panels"}
            count={data?.total_panels || 0}
            Icon={FaSolarPanel}
          />
        </div>
        <div>
          <CountCard
            title={"Users"}
            count={data?.total_users || 0}
            Icon={FaUsers}
          />
        </div>
        <div>
          <CountCard
            title={"Services"}
            count={data?.total_panel_services || 0}
            Icon={MdMiscellaneousServices}
          />
        </div>
      </div>

      <div className="flex justify-around items-start gap-4 flex-wrap contain mt-6">
        <div>
          {data?.panels_stats && (
            <Panels panelsStats={data?.panels_stats || []} />
          )}
        </div>
        <div>
          {data?.users_stats && (
            <Employees usersStats={data?.users_stats || []} />
          )}
        </div>
        <div>{data?.status && <Status statusStats={data?.status || []} />}</div>
      </div>

      <div className="flex justify-around items-start gap-4 flex-wrap contain mt-16">
        <div>
          {data?.roles_stats && <Roles rolesStats={data?.roles_stats || []} />}
        </div>
        <div>
          {data?.payment_method && (
            <PaymentMethods methodsStats={data?.payment_method || []} />
          )}
        </div>
        <div>
          {data?.status_payment && (
            <PaymentStatus paymentsStatusStats={data?.status_payment || []} />
          )}
        </div>
      </div>
    </Styles>
  );
};

export default React.memo(Dashboard);
